import { createAction } from '@wix/communities-blog-client-common';

export const SET_IS_LOADING = 'isLoading/SET';

export const setIsLoading = createAction(
  SET_IS_LOADING,
  (entity: any, id: any, isLoading: any) => ({
    entity,
    id,
    isLoading,
  }),
);
